<template>
  <div class="index" id="anchor">
    <Seacher></Seacher>
    <div class="index_validators">
      <div class="indexbox box3">
        <div class="iboxleft">
          <div class="iboxtit">Total Collections</div>
          <div class="iboxcon">{{ Number(totalNFTs).toLocaleString() }}</div>
        </div>
      </div>
      <div class="indexbox box3">
        <div class="iboxleft">
          <div class="iboxtit">Total NFTs</div>
          <div class="iboxcon">{{ Number(collections).toLocaleString() }}</div>
        </div>
      </div>
      <div class="indexbox box3">
        <div class="iboxleft">
          <div class="iboxtit">Total NFT Holders</div>
          <div class="iboxcon">{{ Number(holders).toLocaleString() }}</div>
        </div>
      </div>
      <div class="indexbox box3">
        <div class="iboxleft">
          <div class="iboxtit">NFTs Created in last 30 days</div>
          <div class="iboxcon">
            {{ Number(pastMonthMintNFTCount).toLocaleString() }}
          </div>
        </div>
      </div>
    </div>

    <!-- translist start -->
    <div class="translist">
      <div class="Block_Top notranslate">
        <span class="notranslate">Non - Fungble Tokens (NFT)</span><br />
        <span class="taketoptit"
          >A total of {{ nftList.length }} Collection Found</span
        >
        <div class="takeseach">
          <input
            type="text"
            id="inputvalue"
            @keyup.enter="search"
            v-model.trim="value"
            placeholder="Search Contract Name or Contract address"
          />
          <img src="../../assets/m/home/seach.png" @click="search" />
        </div>
      </div>

      <div class="resume-list">
        <div class="pool_main">
          <div class="tags">
            <div class="indexList">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>#</li>
                  <li>Collection</li>
                  <li class="xila">Items</li>
                  <li>
                    Holders
                    <!-- <img :src="PaixuImg" > -->
                  </li>
                  <li>
                    Transfers
                    <!-- <img :src="PaixuImg1" > -->
                  </li>
                  <!-- <li>Gas</li> -->
                  <!-- <li>Amount</li> -->
                </ul>
              </div>
              <div class="Block_List_center notranslate">
                <ul>
                  <li v-for="(item, index) in nftList" :key="index">
                    <p class="grays">{{ index + 20 * (pageNum - 1) + 1 }}</p>
                    <p @click="Overview(item.contractAddress)">
                      <img :src="item.logo" style="border-radius: 50%" /><span
                        >{{ item.contractName }}</span
                      >
                    </p>
                    <p class="grays"> {{ Number(item.itemCount).toLocaleString() }}</p>
                    <p class="grays">
                     
                      {{ Number(item.holders).toLocaleString() }}
                    </p>
                    <p class="grays"> {{ Number(item.transactions).toLocaleString() }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            :page-size="20"
            :pager-count="5"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- translist end -->
  </div>
</template>

<script>
import { formatSeconds, getSubStr } from "@/utils/utils";
import Seacher from "@/components/m/Seacher.vue";
import { GetnftList } from "@/assets/server/api";
export default {
  components: {
    Seacher,
  },
  data() {
    return {
      pageSize: 1,
      total: null,
      pageNum: 1,
      collections: "",
      holders: "",
      nftList: [],
      pastMonthMintNFTCount: "",
      totalNFTs: "",
      contractName: "",
      value: "",
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      imgurl1: require("@/assets/pc/Index/indexlogo.png"),
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {
    this.pageNum = 1;
  },
  mounted() {
    this.getContractTxList();
  },
  destroyed() {},
  methods: {
    search() {
      var inputvalue = document.getElementById("inputvalue");
      if (inputvalue.innerHTML == " ") {
        return;
      }
      if (this.value == "") {
        this.contractName = this.value;
        this.pageNum = 1;
        this.getContractTxList();
        // this.$emit("search", this.value);
      } else if (this.value != "") {
        this.contractName = this.value;
        this.pageNum = 1;
        this.getContractTxList();
        //this.$emit("search", this.value);
        this.value = "";
      }
    },
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    Overview(index) {
      this.$router.push({
        path: "/m/NftOveraddress",
        query: { contractAddress: index },
      });
    },
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
    handleCurrentChange(currentPage) {
      sessionStorage.removeItem("tiaozhuan");
      this.pageNum = currentPage;
      // this.setContextData("tiaozhuan", this.pageNum);
      document.querySelector("#anchor").scrollIntoView(true);
      this.getContractTxList();
    },
    async getContractTxList() {
      let formData = new FormData();
      let params = {
        pageNum: this.pageNum,
        pageSize: 20,
        contractName: this.contractName,
      };
      //  console.log(params);
      let item = params;

      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetnftList(formData);
      // console.log(res);
      // collections: '',
      // holders: '',
      // nftList:[] ,
      // pastMonthMintNFTCount: '',
      // totalNFTs: '',
      this.collections = res.result.collections;
      this.holders = res.result.holders;
      this.nftList = res.result.nftList;
      //   console.log( this.nftList);
      this.total = res.result.nftCount;
      this.pastMonthMintNFTCount = res.result.pastMonthMintNFTCount;
      this.totalNFTs = res.result.totalNFTs;
      for (var i = 0; i < this.nftList.length; i++) {
        // if(this.nftList[i].logo=="" || this.check_is_img(this.nftList[i].logo)==false){
        //   this.nftList[i].logo=this.imgurl1;
        // }
        if (
          this.nftList[i].logo == "" ||
          this.check_is_img(this.nftList[i].logo) == false
        ) {
          this.nftList[i].logo = this.imgurl1;
        }
        if (
          this.nftList[i].contractName.trim() == "" ||
          this.nftList[i].contractName == null
        ) {
          this.nftList[i].contractName = getSubStr(
            this.nftList[i].contractAddress,
            0,
            3
          );
        }
      }
    },

    gltimea(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
  },
  watch: {
    $route: {
      handler(val, oldval) {},
      deep: true,
    },
  },
};
</script>
<style lang="less">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>

<style lang="less" scoped>
.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #13161b;
  text-align: center;
  .index_validators {
    width: 750px;
    // height: 572px;
    background: #13161b;
    margin: 0 auto;
    .box3 {
      height: 146px !important;
    }
    .indexbox {
      width: 702px;
      height: 208px;
      background: #000000;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      margin: 0 auto;
      display: flex;
      margin-bottom: 24px;
      justify-content: space-between;
      .iboxleft {
        margin-left: 24px;
        .iboxtit {
          margin-top: 24px;
          height: 34px;
          text-align: left;
          font-size: 24px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #8a8a8a;
          line-height: 34px;
          text-align: left;
        }
        .iboxcon {
          height: 62px;
          font-size: 44px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #00e79a;
          line-height: 62px;
          margin-bottom: 24px;
          margin-top: 2px;
          text-align: left;
        }
      }
      .iboxright {
        margin-right: 24px;
        img {
          margin-top: 64px;
          width: 84px;
          height: 84px;
        }
      }
    }
  }
  .translist {
    width: 100%;
    overflow: hidden;
    margin-top: 24px;
    background: #13161b;
    .Block_Top {
      text-align: left;
      width: 702px;
      margin: 0 auto;
      background: #0b0c0f;
      border-radius: 24px 24px 0 0;
      padding-top: 28px;
      padding-bottom: 28px;

      .taketoptit {
        height: 34px;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #898b8d;
        line-height: 34px;
        margin-left: 24px;
        padding-top: 12px;
      }
      span:nth-child(1) {
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 24px;
      }
      b {
        margin-left: 10px;
      }
      .takeseach {
        display: flex;
        width: 654px;
        height: 74px;
        background: #181b21;
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        margin: 0 auto;
        justify-content: space-between;
        margin-top: 24px;
        input {
          border: none;
          padding-left: 24px;
          width: 578px;
          color: #fff;
          font-size: 24px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          margin-left: 10px;
        }
        img {
          width: 60px;
          height: 60px;
          margin-top: 8px;
          margin-right: 16px;
        }
      }
    }
    //轮播图片开始
    .resume-list {
      width: 702px;
      background: #0b0c0f;
      border-radius: 0 0 24px 24px;
      margin: 0 auto;
      .pool_main {
        width: 100%;
      }
      .tags {
        display: flex;
        overflow: auto;
        white-space: nowrap;
      }
      //隐藏滚动条
      .tags::-webkit-scrollbar {
        display: none;
      }
      // 列表开始
      .indexList {
        width: 100%;
        margin: 0;
        padding: 0;
        background: #0b0c0f;
        .Block_list {
          .block_list_Top {
            display: flex;
            width: 1200px;
            height: 82px;
            line-height: 82px;
            background: #13161b;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            li {
              font-size: 28px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #8a8a8a;
              height: 82px;
              line-height: 82px;
              -webkit-background-clip: text;
              // flex: 0 0 14%;
              text-align: left;
            }
            li:nth-child(1) {
              // border: 1px solid red;
              margin-left: 24px;
              width: 100px;
            }
            li:nth-child(2) {
              width: 300px;
            }
            li:nth-child(3) {
              width: 200px;
            }
            li:nth-child(4) {
              width: 400px;
              img {
                width: 40px;
                height: 34px;
                margin-top: 22px;
              }
            }
            li:nth-child(5) {
              width: 200px;
              img {
                width: 40px;
                height: 34px;
                margin-top: 22px;
              }
            }
          }
        }
        .Block_List_center {
          width: 1200px;
          ul {
            //  height: 620px;
            width: 1200px;
            margin: 0;
            padding: 0;
            //padding: 0 19px;
            li {
              display: flex;
              height: 82px;
              border-bottom: 1px solid #22252e;
              line-height: 82px;
              margin-left: 24px;
              // width: 200px;
              p {
                font-size: 26px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                text-align: left;
                // flex: 0 0 14%;
              }
              .grays {
                color: #898b8d;
              }
            }
            li:last-child {
              // border-bottom: none;
            }
            p:nth-child(1) {
              width: 100px;
              // border: 1px solid red;
            }
            p:nth-child(2) {
              width: 280px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              padding-right: 20px;

              img {
                width: 60px;
                height: 60px;
                margin-top: 12px;
                margin-right: 10px;
              }
            }
            p:nth-child(3) {
              width: 200px;
            }
            p:nth-child(4) {
              width: 400px;
              img {
                width: 30px;
                height: 30px;
                margin-top: 24px;
                margin-right: 10px;
              }
            }
            p:nth-child(5) {
              width: 200px;
            }
          }
        }
      }
      .block {
        margin-top: 70px;
        padding-bottom: 70px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        // line-height: 39px;
      }
    }

    //轮播图片结束
  }
  .list {
    text-align: center;
    padding-bottom: 80px;
    .list-data {
      margin: 0px auto;
      width: 690px;
      min-height: 1377px;
      background: #232a35;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      .head {
        width: 690px;
        padding: 24px 12px;
        background: #232a35;
        opacity: 1;
        border-radius: 16px 16px 16px 16px;
        padding-left: 30px;
        text-align: left;
        height: 48px;
        font-size: 32px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.9);
        line-height: 48px;
      }
      .list-height {
        min-height: 1377px;
        .content_center {
          text-align: left;
          padding: 40px 0px 40px 0px;
          font-size: 26px;
          font-family: "PingFang SC-中黑体, PingFang SC";
          font-weight: normal;
          color: #adb0c7;
          line-height: 36px;
          border-bottom: 1px solid #3c485c;
          margin: 0px 32px;
          div {
            display: flex;
            margin-top: 16px;
            flex-direction: row;
            justify-content: space-between;
            height: 44px;
            line-height: 44px;
            font-size: 28px;
            font-family: SF Pro Text-Medium, SF Pro Text;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.55);
          }
          span {
            padding-bottom: 10px;
            width: 440px;
            text-align: left;
            float: right;
            height: 44px;
            font-size: 28px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            color: #00a870;
            line-height: 44px;
          }
          .black {
            height: 44px;
            font-size: 28px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.9);
            line-height: 44px;
          }
          span:nth-child(4) {
            color: #2c3852 !important;
          }
          span:nth-child(5) {
            color: #2c3852 !important;
          }
        }
      }

      .block {
        margin-top: 32px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
        line-height: 39px;
        padding-bottom: 32px;
      }
    }
  }
}
</style>
